/**
 * GlobalTutorialModal
 * Shows the tutorial as a full-screen modal on top of the current screen.
 * Used when opening tutorial from the menu — no navigation, so closing just dismisses the modal
 * and the underlying page does not reload.
 */

import { View, StyleSheet } from 'react-native';
import { BaseModal } from '../ui/BaseModal';
import { TutorialScreen } from '../tutorial/TutorialScreen';
import { useMenuContext } from '../../src/layout/contexts/MenuContext';

const FULL_SCREEN_POSITION = { top: 0, right: 0, bottom: 0, left: 0 };

export function GlobalTutorialModal() {
  const { tutorialFromMenuVisible, setTutorialFromMenuVisible } = useMenuContext();

  const handleClose = () => {
    setTutorialFromMenuVisible(false);
  };

  return (
    <BaseModal
      isVisible={tutorialFromMenuVisible}
      onDismiss={handleClose}
      backdropOpacity={0}
      dismissible={false}
      contentAlignment="center"
      contentPosition={FULL_SCREEN_POSITION}
      contentContainerStyle={styles.content}
      testID="global-tutorial-modal"
    >
      <View style={styles.inner}>
        <TutorialScreen onClose={handleClose} testID="global-tutorial-modal-screen" />
      </View>
    </BaseModal>
  );
}

const styles = StyleSheet.create({
  content: {
    flex: 1,
    width: '100%',
    height: '100%',
  },
  inner: {
    flex: 1,
    width: '100%',
    height: '100%',
  },
});
